import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';
const LinkMock = React.forwardRef(function NextInnerLink(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <Link {...props} href={props.to} ref={ref} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});
export default LinkMock;